import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/button'

import { BackButton, PageHeader } from '@/components/atoms'

interface CustomerDetailHeaderProps {
  /** Customer name shown as the page title; falls back to "Customer". */
  title?: string
  onSendEmail?: () => void
  onEdit?: () => void
}

export const CustomerDetailHeader = ({ title, onSendEmail, onEdit }: CustomerDetailHeaderProps) => {
  const navigate = useNavigate()

  return (
    <PageHeader
      size="large"
      back={<BackButton onClick={() => navigate('/customers')} label="Back to customers" />}
      title={title || 'Customer'}
      actions={
        <>
          <Button variant="secondary" onClick={onSendEmail}>
            Send email
          </Button>
          <Button onClick={onEdit}>Edit customer</Button>
        </>
      }
    />
  )
}
